import { Injectable } from '@angular/core';
import { GenericResponse } from 'projects/Autofacets-Core/src/app/business-entities/generic-response.class';
import { Observable } from 'rxjs';
import { DataService } from 'projects/Autofacets-Core/src/app/services/data.service';
import { AppConfig } from '../Shared/configs/app.config';
import { Application } from 'projects/Autofacets-Core/src/app/utils/enums';


@Injectable({
  providedIn: 'root'
})
export class CommonLocalizationService {
  moduleLocalizationData: any;
  customerDefaultLanguage: string = null;

  constructor(
    private dataProvider: DataService
  ) { }

  getAllLanguages(): Observable<any> {
    return this.dataProvider.Get(AppConfig.GET_COMMON_LOCALIZATION_LANGUAGE_API_URL);
  }
  getLocalizationData(languageCode: string): Observable<any> {
    return this.dataProvider.GetNonEnc(AppConfig.GET_LOCALIZATION_DATA_FOR_ADMIN_URL, Application[Application.CheckIn], languageCode);
  }
  getApplicationtheme(): Observable<any> {
    return this.dataProvider.Get(AppConfig.GET_SELECTED_THEME)
  }
  GetGenericSettings(): Promise<GenericResponse<any>> {
    return this.dataProvider.Get<any>(AppConfig.GetGenericSettings).toPromise();
  }
  GetSettings(): Promise<GenericResponse<any>> {
    return this.dataProvider.Get<any>(AppConfig.GetSettings).toPromise();
  }
  getFeatures(): Promise<GenericResponse<any>> {
    return this.dataProvider.GetAll<any>(AppConfig.GetFeature).toPromise();
  }

}
